export const integerComparator = (params) => {
    const valueA = params.valueA;
    const valueB = params.valueB;

    if (parseInt(valueA) === parseInt(valueB)) return 0;
    return parseInt(valueA) > parseInt(valueB) ? 1 : -1;
};
